import HeroSection, { HeroSectionProps } from "@components/E-Book/Herosection";
import NewLayout from "@components/new-ui/Layout";
import Image from "next/image";
import React from "react";

const HeroSectionData: HeroSectionProps = {
    title: "Faster Admissions, Better Engagement: The Complete Guide to WhatsApp for Educators",
    listHeading: (
        <p>
            Deploy WhatsApp Business as your marketing and sales engine for your educational institutions, and streamline query resolution, announcements, and real-time updates.
            <br />
            <br />
            With WhatsApp automation by your side, you can:
        </p>
    ),
    listText: [
        { label: "Capture and qualify student info" },
        { label: "Optimize admission processes" },
        { label: "Uncomplicate student onboardin" },
        { label: "Nurture aspirants and engage students" },
        { label: "Connect with parent and alumni groups" },
    ],

    buttonText: "Download your free Ebook now!",
    mediaUrl: "https://assets.gallabox.com/gb-home/ebook/education.png",
    altMedia: "gallabox-e-book",
    ebookName: "education",
};

const EBookWhyWhatsappForEducation: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp Automation for Educators: A Complete Guide - Gallabox eBooks"
            description="Automation tools for WhatsApp are helping a lot of educators and institutions provide quality education at scale. Learn how by downloading this ebook for free"
            canonical="https://gallabox.com/resources/whatsapp-for-education-ebook"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ebook/education-og.png" }}
        >
            <HeroSection {...HeroSectionData} />
            <section className="flex flex-col pb-10 pr-12">
                <div className="px-8 max-w-6xl mx-auto client-logos flex flex-col gap-3">
                    <Image width={221} height={56} src="/frame.png" alt={"Frame"} className="flex-shrink" />
                    <div className="lg:flex justify-between items-center">
                        <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-14">Trusted by over 2,000 companies across 40+ countries</h3>
                        <div className="flex justify-center mb-9">
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:block hidden"
                            />
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:hidden"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </NewLayout>
    );
};

export default EBookWhyWhatsappForEducation;
